module.exports = __webpack_public_path__ + "static/media/shop_80.a20473fc.png";